module.exports = __webpack_public_path__ + "static/media/rightAr.b7f5ccdc.svg";